import { MESApiService, ResponseMESF, spParameter } from "@dexteel/mesf-core";

export const getBilletsYardStatistics = async (
  start: Date,
  end: Date,
): Promise<ResponseMESF> => {
  const apiService = new MESApiService();
  let sqlParameters = [];
  sqlParameters.push({ name: "StartDate", value: start.toISOString() });
  sqlParameters.push({ name: "EndDate", value: end.toISOString() });

  return await apiService.callV2(
    "[BYI].[GetStaticticYardDailyIG]",
    sqlParameters,
  );
};
